import {
  academicProgramListWizardReactiveVars,
  emptyAcademicProgramListWizardCache,
} from '../../cache/learner/academicProgramListWizardVars';

interface IAcademicProgramListWizardHook {
  clearAcademicProgramListWizardError: () => void;
  setAcademicProgramListWizardError: (errorMessage: string) => void;
  setAcademicProgramListWizard: (academicProgramList: string[]) => void;
}

const useAcademicProgramListWizardHook = (): IAcademicProgramListWizardHook => {
  const clearAcademicProgramListWizardError = (): void => {
    academicProgramListWizardReactiveVars(emptyAcademicProgramListWizardCache);
  };
  const setAcademicProgramListWizardError = (errorMessage: string): void => {
    academicProgramListWizardReactiveVars({ ...emptyAcademicProgramListWizardCache, error: errorMessage });
  };

  const setAcademicProgramListWizard = (academicProgramList: string[]): void => {
    academicProgramListWizardReactiveVars({
      error: '',
      data: academicProgramList,
    });
  };

  return {
    clearAcademicProgramListWizardError,
    setAcademicProgramListWizardError,
    setAcademicProgramListWizard,
  };
};

export default useAcademicProgramListWizardHook;
